import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
var colors = tokens.colors;
export var membershipMenu = /*#__PURE__*/css();
export var profile = /*#__PURE__*/css("background-color:", colors.neutral.subdued.default, ";");
export var menuItem = {
  name: "k008qs",
  styles: "display:flex;"
};
export var icon = /*#__PURE__*/css("color:", colors.neutral.medium.default, ";");